import { h, Fragment } from "preact";
import { useState, } from "preact/hooks";

import {
	Button,
	Box,
	Paper,
	Stack,
	TextField,
	Tooltip,
	Typography,

} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CardTemplate from "../Common/CardTemplate";

export default function ChangeDealName({ actualDeal }) {

	const [state, setState] = useState({ name_beeing_edited: false });
	const handleChange = (event) => {

		setState({ ...state, [event.target.name]: event.target.value });
	};

	const handleSubmitEditName = () => {

		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ name: state.dealName }),
		};
		fetch("/api/e73ca0e1e2634523b8f7173a77d6407c/" + actualDeal.deal_uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						window.location.reload();

						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};

	return (
		<CardTemplate
			title="Nom du dossier"
			buttons={<Fragment>
				{
					actualDeal.idp && !state.name_beeing_edited && (
						<Tooltip title="Changer le nom">
							<Button
								variant="outlined"
								style="color: black; border-color: black;"
								onClick={() => { setState({ ...state, name_beeing_edited: true }) }}
							>
								<EditIcon />
							</Button>
						</Tooltip>)}
			</Fragment>}
			content={
				< Fragment >

					< Typography variant="body1" > {actualDeal.name}</Typography >
					{
						state.name_beeing_edited && (<Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
							<TextField
								id="dealName"
								name="dealName"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Nom"
								fullWidth
								margin="dense"
								size="small"
								value={state.dealName ? state.dealName : actualDeal.name}
								onChange={handleChange}
							/>
							<Button variant="contained"
								onClick={handleSubmitEditName}>Changer</Button>

						</Stack>
						)
					}
				</Fragment >
			}
		/>)





}